module.exports = __webpack_public_path__ + "media/images/menu/andromeda-a8f984b83eb49de688b9222b98a19df0.jpg";